import { Component, ElementRef, HostListener, OnDestroy, OnInit, Inject, TemplateRef, ViewChild } from "@angular/core";
import { CommonService } from '../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ShareCodeAddTeamsComponent } from '../share-code-add-teams/share-code-add-teams.component';
import { Route, Router } from '@angular/router';
import { ImageTransform } from 'ngx-image-cropper';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { SpinnerVisibilityService } from "ng-http-loader";
import { PlayerDetailsDialogueComponent } from "../player-details/player-details-dialogue.component";
import { ClubServicesService } from "../../services/club-services.service";
import { debounceTime, tap, switchMap, finalize, distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { AddteamsModalComponent } from "../addteams-modal/addteams-modal.component";


@Component({
  selector: 'app-add-player-modal',
  templateUrl: './add-player-modal.component.html',
  styleUrls: ['./add-player-modal.component.scss']
})
export class AddPlayerModalComponent implements OnInit {
  // ********************************************************************************************
  // VARIABLE START
  imgURL: any = 'assets/icon/add-team.png';
  fileName: any;
  submitted: boolean = false;
  sharedCodeVal: any = "";
  modalRef: BsModalRef;
  croppedProfilePicRef: any;
  imageChangedEvent: any = '';
  profilePicCropperUrl: any;
  originalProfilePicRef: any;
  originalProfilePicName: any;
  imageTransform: ImageTransform = {};
  checkImage: any;
  @ViewChild("ProfilePicCropModal") ProfilePicCropModal: TemplateRef<any>;
  currentUser: any = localStorage.getItem("currentUser")
  defaultImage = '../../../../assets/icons/Loading_icon.gif';
  minLengthTerm = 1;
  errorMsg!: string;
  isLoading = false;
  playersList:any=[];
  selectedValuePlayer: any;
  selectedPlayer: any;

  // VARIABLE END
  // ********************************************************************************************


  // ********************************************************************************************
  // Default FN START
  constructor(
    private csObj: CommonService,
    private toast: ToastrService,
    private fb: FormBuilder,
    private dialogue: MatDialog,
    private router: Router,
    private modalService: BsModalService,
    private spinner: SpinnerVisibilityService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clubService: ClubServicesService
  ) { }

  addTeamForm = this.fb.group({
    addteamName: new FormControl(this.data.userType.teamName, [Validators.required]),
  });


  ngOnInit(): void {
    this.initAutoCompleteModel();
    if (this.data.userType.access == 'edit') {
      console.log(this.data.userType.teamName, "teamName")
      this.imgURL = this.data.userType.imgPath;
      // this.addTeamForm.value.addteamName = this.data.userType.teamName
    }
  }


  get f() {
    return this.addTeamForm.controls
  }
  // Default FN END
  // ********************************************************************************************


  addTeamPlayer() {
    if (!this.selectedValuePlayer) {
      return
    }
    try {
      let data = {"teamId": this.data?.userType?.id,"playerId": this.selectedValuePlayer};
      console.log(data);

      this.clubService.addTeamPlayer(data).subscribe((res: any) => {
        if (res.status == 200) {
          if(this.selectedValuePlayer){
            this.toast.success('Players added successfully');
          }else{
            this.toast.success("Team created successfully.");
          }

          this.csObj.callTeamList(true);

          // let currentURL = this.router.url
          // this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
          //   this.router.navigate([currentURL]);
          // });
        } else {
          this.toast.error(res.message)
        }
      }, (err: any) => {
        this.toast.error(err.error.error.message);
      })
    }
    catch (e) { }
  }


  CloseModal() {
    let currentURL = this.router.url;
    console.log(this.data.userType.details.players);
    this.editFNCall(this.data.userType.details._id,this.data.userType.details.logo,this.data.userType.details.name, this.data.userType.details);
    // this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
    //   this.router.navigate([currentURL]);
    // });
  }


  editFNCall(id: any, logo: any, name: any,player:any) {
    try {

      var userType = JSON.parse(this.currentUser)
      this.dialogue.open(AddteamsModalComponent, {
        hasBackdrop: true,
        disableClose: true,
        data: {
          userType: {
            titleOne: '',
            titleTwo: '',
            text: "",
            user: userType.userType,
            imgPath: logo,
            id: id,
            team:player,
            access: 'edit',
            teamName: name
          }
        },
      });
    }
    catch (e) { }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  openAddPlayerModal(){
    this.dialogue.open(PlayerDetailsDialogueComponent, {
      hasBackdrop: true,
      id: 'addmore-model',
      disableClose: true,
      data: {
        userType: {
          titleOne: 'Add Player',
          titleTwo: '',
          text: "",
          // imgPath: this.imgURL,
          id: '',
          access: 'add',
          teamName: ''
        }
      },
    });
  }

  displayWithPlayer(value: any) {
    if(value?.firstName && value?.lastName){
      return value?.firstName + " " + value?.lastName;
    }
    else if(value?.firstName){
      return value?.firstName;
    }
    else if(value?.lastName){
      return value?.lastName;
    }
  }

  clearPlayer() {
    this.selectedValuePlayer = '';
  }

  onSelectedPlayer(e: any) {
    this.selectedValuePlayer = e.option.value._id;
  }

  playerForm = new FormGroup({
    playerName: new FormControl('', [Validators.required]),
  })

  initAutoCompleteModel() {
    this.playerForm.get('playerName').valueChanges
      .pipe(
        filter(res => {
          return res !== null && res.length >= this.minLengthTerm
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.playersList = [];
          this.isLoading = true;
        }),
        switchMap(value => this.clubService.searchTeamPlayer(
          {"search": value}
        )
          .pipe(
            finalize(() => {
              this.isLoading = false
            }),
          )
        )
      )
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.playersList = [];
          this.playersList = res.output;
        } else {
          this.playersList = [];
        }
      });
  }
}
